export const TEXT_TO_IMAGE_POLL_ID = 'app/text-to-image/text-to-image-poll-id';
